module.exports = __webpack_public_path__ + "static/media/8@2x.8312f848.png";